import { render, staticRenderFns } from "./DirectChatBlock.vue?vue&type=template&id=1e73c22b&"
import script from "./DirectChatBlock.vue?vue&type=script&lang=js&"
export * from "./DirectChatBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports